import type { BuilderType } from '@shared/utils/api/configs/rtkBaseQueryDemo';
import { UPDATE_TERMS_OF_USE_URL } from '@shared/utils/api/configs/URL';
import { hasCcdpSuccess } from '@shared/utils/api/handlers/interpretCcdpCode/interpretCcdpCode';
import type { GenericApiResponse } from '@shared/utils/api/types';

import { TERMS_OF_USE_TAGS } from './getTermsOfUse';
import type { UpdateTermsOfUsePayload, UpdateTermsOfUseResult } from '../types/updateTermsOfUse.types';

export const updateTermsOfUse = (builder: BuilderType) =>
  builder.mutation<UpdateTermsOfUseResult, UpdateTermsOfUsePayload>({
    query: (payload) => ({
      data: payload,
      method: 'POST',
      url: UPDATE_TERMS_OF_USE_URL,
    }),
    invalidatesTags: [TERMS_OF_USE_TAGS],
    transformResponse: (response: GenericApiResponse<UpdateTermsOfUseResult>) => {
      if (hasCcdpSuccess(response)) {
        return response.Result;
      }

      throw {
        code: response.Code,
        message: response.Message,
      };
    },
  });
